import { render, staticRenderFns } from "./EdicionPlanes.vue?vue&type=template&id=71b482cd&"
import script from "./EdicionPlanes.vue?vue&type=script&lang=js&"
export * from "./EdicionPlanes.vue?vue&type=script&lang=js&"
import style0 from "./EdicionPlanes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports